/**
 * Footer 社交入口 btn/trackName → global_wap 表 footer_social.social_entry_XX 坑位
 * 固定映射。SDSocialMediaClick 点击上报（FooterV2/index.tsx）与各终端 Footer 变体
 * （2026-pc / 2026-wap）的 Data SPM DOM 打标共用本表，保证编码同源；global_pc 表
 * 无 footer_social 模块，PC 查表自然不附加。
 *
 * 独立成无依赖的小模块：避免变体组件为取这张映射表反向依赖 index.tsx（后者
 * 引入 store / reporting 等重型依赖图，会拖垮纯布局类单测的 mock 清单）。
 */
export const FOOTER_SOCIAL_POSITION: Record<string, string> = {
  ins: 'social_entry_01',
  fb: 'social_entry_02',
  tiktok: 'social_entry_03',
  twitter: 'social_entry_04',
  youtube: 'social_entry_05',
};
